import { useMemo } from "react";
import { create } from "zustand";
// import { merge } from "merge-anything";
// import _ from "lodash";
// import merge from "ts-deepmerge";
import { persist } from "zustand/middleware";

// slices
import { appSlice, appActions } from "./app";
import { changeTicketsSlice, changeTicketsActions } from "./change-tickets";
import { cmsSlice, cmsActions } from "./cms";
import { giftCardSlice, giftCardActions } from "./giftCard";
import { modalsSlice, modalsActions } from "./modals";
import { paymentSlice, paymentActions } from "./payment";
import { refundSlice, refundActions } from "./refund";
import { searchSlice, searchActions } from "./search";
import { ssrDataSlice, ssrDataActions } from "./ssrData";
import { ticketsSlice, ticketsActions } from "./tickets";
import { userSlice, userActions } from "./user";

const STORAGE_NAME = "luxexpress-storage";
let store;

// const obj1 = {
//   prop1: {
//     name: "Serg",
//     age: 32,
//   },
//   prop2: {
//     skills: {
//       "en": "test-2",
//       "et": "test-2-et",
//       "ru": "test-2-ru",
//       "fi": null,
//       "lv": null,
//       "lt": null,
//       "pl": null
//     },
//     key: "val",
//   },
// };

// const obj2 = {
//   prop1: {
//     secondName: "Che",
//     age: 33,
//   },
//   prop2: {
//     skills: {
//       "en": "/",
//       "et": "/",
//       "ru": "/",
//       "fi": null,
//       "lv": null,
//       "lt": "/",
//       "pl": "/"
//     },
//     key: "val",
//     lang: "en",
//   },
// };

// const result = _.mergeWith(obj1, obj2, (objValue, srcValue) => {
//   if (_.isArray(objValue)) {
//     return srcValue;
//   }
// },);

// console.log("result", result);

function initStore(preloadedState = null) {
  const store = create(
    persist(
      (set, get) => {
        const mergeResult = {
          cms: cmsSlice(set, get),
          search: searchSlice(set, get),
          user: userSlice(set, get),
          refund: refundSlice(set, get),
          tickets: ticketsSlice(set, get),
          changeTickets: changeTicketsSlice(set, get),
          app: appSlice(set, get),
          modals: modalsSlice(set, get),
          giftCard: giftCardSlice(set, get),
          ssrData: ssrDataSlice(set, get),

          // actions
          ...cmsActions(set, get),
          ...searchActions(set, get),
          ...userActions(set, get),
          ...refundActions(set, get),
          ...paymentActions(set, get),
          ...ticketsActions(set, get),
          ...changeTicketsActions(set, get),
          ...appActions(set, get),
          ...modalsActions(set, get),
          ...giftCardActions(set, get),
          ...ssrDataActions(set, get),
        };

        return mergeResult;
      },
      {
        name: STORAGE_NAME, // unique name
        version: 108,
        // merge: (persistedState, currentState) => {
        //   return merge(currentState, persistedState);
        // },
        // onRehydrateStorage: (state) => {
        //   console.log("hydration starts", state);
        // },
        // getStorage: () => localStorage, // (optional) by default, 'localStorage' is used
      },
    ),
  );

  return store;
}

export const initializeStore = (preloadedState) => {
  const _store = store ?? initStore(preloadedState);

  // For SSG and SSR always create a new store
  if (typeof window === "undefined") {
    return _store;
  }
  // Keep client actions/subscriptions attached across locale and page changes.
  // _app updates SSR page data separately through updateSsrData.
  if (!store) store = _store;

  return _store;
};

export function useHydrate(initialState) {
  const state =
    typeof initialState === "string" ? JSON.parse(initialState) : initialState;

  const store = useMemo(() => {
    return initializeStore(state);
  }, [state]);

  return store;
}
